/* Publish by EComposer at 2026-10-12 05:05:07*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a3pnxnocwmf"]=  window.__ectimmers["ecom-a3pnxnocwmf"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a3pnxnocwmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3pnxnocwmf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rkh3idp3gb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rkh3idp3gb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0tn8fzauexwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0tn8fzauexwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xq6o0eis09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xq6o0eis09', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2b8yy2fju4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2b8yy2fju4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lx8vzr3328e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lx8vzr3328e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckfbgtkngqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckfbgtkngqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h37v5cmkhgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h37v5cmkhgw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-00ueerodom9ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-00ueerodom9ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdyxzu3yf4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdyxzu3yf4r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zkpgalzikh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zkpgalzikh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su8mpay8yk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su8mpay8yk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7olhcsmjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7olhcsmjk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6pl9ujrlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6pl9ujrlu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9b22uaoxhq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9b22uaoxhq6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pjmdpmboux').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pjmdpmboux', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t3gyif4iojq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t3gyif4iojq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5nz3xp48id').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5nz3xp48id', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlfz6qfjgkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlfz6qfjgkm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jp9hfu6e3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jp9hfu6e3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vnyvrpo5ct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vnyvrpo5ct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjhovzqz45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjhovzqz45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpxs31ok04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpxs31ok04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfsvwiueiq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfsvwiueiq8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5lbo4p9lx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5lbo4p9lx9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jy7jss3bfrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jy7jss3bfrk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3hu4q4cq3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3hu4q4cq3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ga0kkt2g7rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ga0kkt2g7rb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2wf57v077l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2wf57v077l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-00ph9afjcwbkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-00ph9afjcwbkk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5h999bqtn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5h999bqtn8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pdt2zazrbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pdt2zazrbx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5rtu4hlwxxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rtu4hlwxxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bnek5bjcbpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bnek5bjcbpf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tx3bwg9037').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tx3bwg9037', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8ab3gjw9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8ab3gjw9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77b6be1qzvw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77b6be1qzvw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cw6a4m2fs84').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cw6a4m2fs84', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iik1te2fv8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iik1te2fv8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9ac0tikdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9ac0tikdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y8k97wro3ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y8k97wro3ci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85gfmbuq9sy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85gfmbuq9sy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48xm3soibi5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48xm3soibi5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrbmb4wock').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrbmb4wock', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94z81ibsyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94z81ibsyc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pentlyk14t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pentlyk14t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gcwe04hkuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gcwe04hkuh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hz8alw1tjkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hz8alw1tjkg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xhv895r13w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xhv895r13w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfnth4tewew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfnth4tewew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fxwqkec278').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fxwqkec278', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n1099rfaheh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n1099rfaheh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g2x4dxni6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g2x4dxni6k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grc90atiq0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grc90atiq0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ulzmebbk8te').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ulzmebbk8te', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gw3rs0730sf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gw3rs0730sf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06eyp11muei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06eyp11muei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4t9nmz537').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4t9nmz537', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zu91nxp1dk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu91nxp1dk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jilcr4pn53').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jilcr4pn53', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj3cfezu18j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj3cfezu18j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cs38iiw2p8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cs38iiw2p8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fcu6p81zdie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fcu6p81zdie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcdv4onnkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcdv4onnkk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-crwxl5j7fgc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-crwxl5j7fgc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-007gpqzfc7owx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-007gpqzfc7owx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e52k2u7fjx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e52k2u7fjx7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywnjx1nazs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywnjx1nazs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dl6oud97j3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dl6oud97j3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1k5jtlxma6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1k5jtlxma6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p98aai6togd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p98aai6togd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3mkvvopll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3mkvvopll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbhz1pfkfor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbhz1pfkfor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cofngutmqxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cofngutmqxi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ov4dmjmu3sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ov4dmjmu3sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ml0lty5plr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ml0lty5plr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7tfndg88xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7tfndg88xj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzh63yclzbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzh63yclzbc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpgdh74cewj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpgdh74cewj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38is1h0ssf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38is1h0ssf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egn1tlej3zh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egn1tlej3zh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1mf750viz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1mf750viz8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybfa7p4kw7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybfa7p4kw7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ohz4nmjk7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ohz4nmjk7j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jzuutmzyaom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzuutmzyaom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urfawtii6ej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urfawtii6ej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3prmzfdpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3prmzfdpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9dbjppbkd7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9dbjppbkd7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8q4mf7mvz7y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8q4mf7mvz7y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ij2h1vvgr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ij2h1vvgr8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1ypxfas24').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1ypxfas24', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7kjxi7gwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7kjxi7gwt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v45xapfbjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v45xapfbjz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8o2le5n5ty8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8o2le5n5ty8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fox52xwu6zj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fox52xwu6zj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22215555wy2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22215555wy2', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-b97geq9ccc"]=  window.__ectimmers["ecom-b97geq9ccc"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-b97geq9ccc"]["u3ea2o5dn"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-b97geq9ccc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b97geq9ccc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93p4arc3xq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93p4arc3xq6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tg62zgegkee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tg62zgegkee', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bvc6u0zvr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bvc6u0zvr9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qjhb1p2e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qjhb1p2e4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1plcxbp19o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1plcxbp19o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi9l6wkbkrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi9l6wkbkrh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sghkg7z6sa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sghkg7z6sa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lqcb8yfs8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lqcb8yfs8h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ylfkjqydfr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ylfkjqydfr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxppwzkhhmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxppwzkhhmp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzj92f5wb2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzj92f5wb2e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pt77m4bi03b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pt77m4bi03b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0i6f1j80ns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0i6f1j80ns', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s08lqpaf9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s08lqpaf9a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjsmqlc2j8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjsmqlc2j8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdithuqfdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdithuqfdo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s774kp6oy9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s774kp6oy9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2agw5i1s7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2agw5i1s7p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xadptb10fje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xadptb10fje', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pt14j3oa8zn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pt14j3oa8zn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6ornu50b2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6ornu50b2k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-szivms8jmxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-szivms8jmxa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33wdazof24b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33wdazof24b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ge5hykqcdqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ge5hykqcdqh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ny4mtpr1bbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ny4mtpr1bbk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sgfbfvpw02h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sgfbfvpw02h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2axgsky238d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2axgsky238d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7d2ahsk1js').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7d2ahsk1js', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22abn5fen45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22abn5fen45', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82yfjxy8nx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82yfjxy8nx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4qqxc4ati').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4qqxc4ati', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7cp56xw821n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7cp56xw821n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ditteybqp8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ditteybqp8j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i83ne6vyiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i83ne6vyiq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4spwk3gm5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4spwk3gm5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wxdblfsd7y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wxdblfsd7y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxbmwmt5vnu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxbmwmt5vnu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mljorgz6d6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mljorgz6d6', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9a0ny1wht1"]=  window.__ectimmers["ecom-9a0ny1wht1"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const s=document.querySelectorAll(".ecom-container-lightbox-"+e);s.length&&s.forEach(function(r){const a=r.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const l=r.querySelector("video");l!=null&&l.pause()})},o=function(s){if(window.EComModal)return s();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&s()});return}let r=0;const a= window.__ectimmers["ecom-9a0ny1wht1"]["8n02uli4v"] = setInterval(function(){window.EComModal?(clearInterval(a),s()):++r>=300&&clearInterval(a)},50)},n=this.id;t&&o(function(){var s=t.querySelector("[ecom-modal]");new window.EComModal(s,{cssClass:["ecom-container-lightbox-"+n,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const r=document.querySelectorAll(".ecom-container-lightbox-"+e);r.length&&(r.forEach(function(a){const l=a.querySelector("iframe");if(l!=null){const d=l.src.replace("muted=1","muted=0").replace("mute=1","mute=0");l.src=d}const c=a.querySelector("video");c!=null&&c.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:r}})))},onClose:i})}),i()

                    });
                    
                        document.querySelectorAll('.ecom-9a0ny1wht1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9a0ny1wht1', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hftycd106sb"]=  window.__ectimmers["ecom-hftycd106sb"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-hftycd106sb"]["4xvfin808"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-hftycd106sb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hftycd106sb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-stjkpf8rgmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-stjkpf8rgmh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9m2301lpfyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m2301lpfyq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3up8gkz56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3up8gkz56', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ecegibtcno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ecegibtcno', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9bzf5e9ly').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9bzf5e9ly', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6tofstoymo8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6tofstoymo8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7hjfpgn0ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7hjfpgn0ws', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b953m8lav8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b953m8lav8c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64bbpg5ikz6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64bbpg5ikz6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fd4z0duch85').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fd4z0duch85', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-varq7jr8rvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-varq7jr8rvb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9w0z0fmfgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9w0z0fmfgf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-skaarpufjad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-skaarpufjad', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1149s0z0l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1149s0z0l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ur4e80nanij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ur4e80nanij', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31ewvfh8q4v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31ewvfh8q4v', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sw0invhca7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sw0invhca7', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mn8x6k28029').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mn8x6k28029', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywncq4ys3v9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywncq4ys3v9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkjt725ku2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkjt725ku2e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5um95hz2yi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5um95hz2yi', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16r2nemfzpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16r2nemfzpf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ovv6c6460g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ovv6c6460g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6cbfs85n97b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6cbfs85n97b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7i54vdp5oj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7i54vdp5oj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30lmtjjs5un').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30lmtjjs5un', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14h659dpscq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14h659dpscq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcam05swsje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcam05swsje', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kricos886k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kricos886k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}